import { forwardRef, useEffect, useState } from "react";
import Image from "next/image";
import { Avatar, Typography, useColorScheme } from "@mui/material";

const NextAvatar = forwardRef(function NextAvatar(
  {
    src,
    alt,
    priority = true,
    brokenBgcolor,
    fallback,
    size = 30,
    sx = {},
    ...props
  },
  ref
) {
  const { mode, systemMode } = useColorScheme();
  const [error, setError] = useState(!src);

  useEffect(() => {
    setError(!src);
  }, [src]);

  return (
    <Avatar
      ref={ref}
      sx={{
        height: size,
        width: size,
        color: "var(--surface-variant)",
        position: "relative",
        bgcolor: brokenBgcolor
          ? error
            ? brokenBgcolor
            : "var(--surface-variant)"
          : mode === "dark" || systemMode === "dark"
          ? "var(--surface-inverse-color)"
          : "transparent",
        ...sx
      }}
      {...props}
    >
      {error ? (
        fallback || (
          <Typography variant="bodyMd" textTransform="capitalize">
            {alt?.[0]}
          </Typography>
        )
      ) : (
        <Image
          fill
          priority={priority}
          sizes={`${size}px`}
          alt={alt || "avatar"}
          src={src}
          referrerPolicy="no-referrer"
          style={{ objectFit: "cover" }}
          onError={() => setError(true)}
        />
      )}
    </Avatar>
  );
});

export default NextAvatar;
